import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BannerEditor from "@/pages/BannerEditor";
import Player from "@/pages/Player";
import PosterList from "@/pages/PosterList";
import PosterEditor from "@/pages/PosterEditor";
import Administration from "@/pages/Administration";
import TvPlayer from "@/pages/TvPlayer";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { AppNav } from "@/components/AppNav";

const Protected = ({ children, principal }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (principal && user.role !== "principal") return <Navigate to="/" replace />;
  return children;
};

const Page = ({ children, principal }) => (
  <Protected principal={principal}><AppNav />{children}</Protected>
);

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/tv/:id" element={<TvPlayer />} />
            <Route path="/tv" element={<TvPlayer />} />
            <Route path="/ecran/:code" element={<TvPlayer />} />
            <Route path="/usc/visueltv" element={<TvPlayer />} />
            <Route path="/" element={<Page><Dashboard /></Page>} />
            <Route path="/banner/:id" element={<Page><BannerEditor /></Page>} />
            <Route path="/play/:id" element={<Protected><Player /></Protected>} />
            <Route path="/posters" element={<Page principal><PosterList /></Page>} />
            <Route path="/poster/:id" element={<Page principal><PosterEditor /></Page>} />
            <Route path="/admin" element={<Page principal><Administration /></Page>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
